// Domain-based branding configuration
export const BRANDING_CONFIG = {
  "isogyaan.com": {
    name: "ISOGyaan",
    fullName: "ISOGyaan Professional Learning Platform",
    tagline: "Professional ISO Certification Training in India",
    description:
      "Master ISO certifications with India's leading professional training platform. ISO 9001, 14001, 45001, 27001 certification courses. Exemplar Global accredited programs for quality management careers.",
    siteUrl: "https://isogyaan.com",
    email: "info@isogyaan.com",
    phone: "+91 90198 85055",
    address: {
      city: "Bengaluru, India",
      street: "10th floor, RMZ Latitude, Hebbal",
    },
    logo: "/assets/branding/isogyaan.png",
    logoFull: "/assets/branding/isogyaan-full.png",
    ogImage: "/assets/branding/isogyaan-full.png",
    locale: "en_IN",
    social: {
      twitter: "@isogyaan",
      linkedin: "isogyaan",
    },
    geo: {
      region: "IN-KA",
      country: "India",
      placename: "Bengaluru",
    },
    meta: {
      title:
        "ISOGyaan - Professional ISO Certification Training in India | Quality Management Careers",
      description:
        "Master ISO certifications with India's leading professional training platform. ISO 9001, 14001, 45001, 27001 certification courses. Exemplar Global accredited programs for quality management careers.",
      keywords:
        "ISO certification, quality management, ISO 9001, ISO 14001, ISO 45001, ISO 27001, professional training, India",
    },
  },
  "skillcompliance.com": {
    name: "SkillCompliance",
    fullName: "SkillCompliance Professional Learning Platform",
    tagline: "Professional ISO Certification Training",
    description:
      "Master ISO certifications with our leading professional training platform. ISO 9001, 14001, 45001, 27001 certification courses. Exemplar Global accredited programs for quality management careers.",
    siteUrl: "https://skillcompliance.com",
    email: "info@skillcompliance.com",
    phone: "+1-647-678-8284",
    address: {
      city: "Toronto, Canada",
      street: "18 King Street East, Suite 1400",
    },
    logo: "/assets/branding/skillcompliance-square.png",
    logoFull: "/assets/branding/skillcompliance-full.png",
    ogImage: "/assets/branding/skillcompliance-full.png",
    locale: "en_US",
    social: {
      twitter: "@skillcompliance",
      linkedin: "skillcompliance",
    },
    geo: {
      region: "US-NY",
      country: "USA",
      placename: "New York",
    },
    meta: {
      title:
        "SkillCompliance - Professional ISO Certification Training | Quality Management Careers",
      description:
        "Master ISO certifications with our leading professional training platform. ISO 9001, 14001, 45001, 27001 certification courses. Exemplar Global accredited programs for quality management careers.",
      keywords:
        "ISO certification, quality management, ISO 9001, ISO 14001, ISO 45001, ISO 27001, professional training",
    },
  },
  "skillcompliance.ca": {
    name: "SkillCompliance",
    fullName: "SkillCompliance Professional Learning Platform",
    tagline: "Professional ISO Certification Training in Canada",
    description:
      "Master ISO certifications with Canada's leading professional training platform. ISO 9001, 14001, 45001, 27001 certification courses. Exemplar Global accredited programs for quality management careers.",
    siteUrl: "https://skillcompliance.ca",
    email: "info@skillcompliance.ca",
    phone: "+1-647-678-8284",
    address: {
      city: "Toronto, Canada",
      street: "18 King Street East, Suite 1400",
    },
    logo: "/assets/branding/skillcompliance-square.png",
    logoFull: "/assets/branding/skillcompliance-full.png",
    ogImage: "/assets/branding/skillcompliance-full.png",
    locale: "en_CA",
    social: {
      twitter: "@skillcompliance",
      linkedin: "skillcompliance",
    },
    geo: {
      region: "CA-ON",
      country: "Canada",
      placename: "Toronto",
    },
    meta: {
      title:
        "SkillCompliance Canada - Professional ISO Certification Training | Quality Management Careers",
      description:
        "Master ISO certifications with Canada's leading professional training platform. ISO 9001, 14001, 45001, 27001 certification courses. Exemplar Global accredited programs for quality management careers.",
      keywords:
        "ISO certification, quality management, ISO 9001, ISO 14001, ISO 45001, ISO 27001, professional training, Canada",
    },
  },
  "procertcompliance.com": {
    name: "ProCertCompliance",
    fullName: "ProCertCompliance ISO Training Platform",
    tagline: "Professional ISO Training & Certification Platform",
    description:
      "Professional ISO certification training platform. World-class course content with accredited programs for quality management careers.",
    siteUrl: "https://procertcompliance.com",
    email: "info@skillcompliance.com",
    phone: "+1-647-678-8284",
    address: {
      city: "Toronto, Canada",
      street: "18 King Street East, Suite 1400",
    },
    logo: "/assets/branding/procert-logo.png",
    logoFull: "/assets/branding/procert-logo.png",
    ogImage: "/assets/branding/procert-logo.png",
    locale: "en_US",
    social: {
      twitter: "@procertcompliance",
      linkedin: "procertcompliance",
    },
    geo: {
      region: "US-NY",
      country: "USA",
      placename: "New York",
    },
    meta: {
      title:
        "ProCertCompliance - Professional ISO Training & Certification Platform",
      description:
        "Professional ISO certification training platform. World-class course content with accredited programs for quality management careers.",
      keywords:
        "ISO certification, ISO training, compliance training, professional certification platform",
    },
  },
};

// Partner white-label context injected by the Netlify edge function as
// <meta> tags on the initial HTML. Read synchronously so module-load-time
// callers (e.g. the exported BRANDING constant) see the partner brand.
const getPartnerContextFromDOM = () => {
  if (typeof document === "undefined") return null;
  const whiteLabel =
    document.querySelector('meta[name="x-white-label"]')?.content === "true";
  const slug = document.querySelector('meta[name="x-partner-slug"]')?.content;
  if (!whiteLabel && !slug) return null;
  const name = document.querySelector('meta[name="x-partner-name"]')?.content;
  return {
    slug: slug || null,
    name: name || slug || null,
  };
};

// Get current domain
export const getCurrentDomain = () => {
  const host = typeof window === "undefined" ? "" : window.location.hostname.toLowerCase().replace(/^www\./, "");
  if (getPartnerContextFromDOM() || (typeof window !== "undefined" && window.location.pathname?.startsWith('/w/'))) return "procertcompliance.com";
  if (BRANDING_CONFIG[host]) return host;
  if (host.endsWith('.procertcompliance.com')) return 'procertcompliance.com';
  if (host && host !== 'localhost' && host !== '127.0.0.1' && !host.endsWith('.netlify.app')) return 'procertcompliance.com';
  // Check for Vite environment variable first (set via npm scripts)
  // This allows local development to test different platforms
  const envPlatform = import.meta.env?.VITE_PLATFORM;
  if (
    envPlatform === "skillcompliance-ca" ||
    envPlatform === "cad" ||
    envPlatform === "ca"
  ) {
    return "skillcompliance.ca";
  }
  if (envPlatform === "skillcompliance" || envPlatform === "usd") {
    return "skillcompliance.com";
  }
  if (envPlatform === "isogyaan" || envPlatform === "inr") {
    return "isogyaan.com";
  }

  // Check for ProCert development mode on localhost
  const isProCertDev = import.meta.env?.VITE_SHOW_PROCERT_HOME === "true";
  if (
    typeof window !== "undefined" &&
    window.location.hostname === "localhost" &&
    isProCertDev
  ) {
    return "procertcompliance.com";
  }

  if (typeof window === "undefined") {
    // Server-side rendering fallback - check environment or use default
    const siteUrl = process.env.VITE_SITE_URL || "";
    if (siteUrl.includes("procertcompliance")) {
      return "procertcompliance.com";
    }
    if (siteUrl.includes("skillcompliance.ca")) {
      return "skillcompliance.ca";
    }
    if (siteUrl.includes("skillcompliance.com")) {
      return "skillcompliance.com";
    }
    return "isogyaan.com";
  }

  const hostname = window.location.hostname.toLowerCase();

  // Check for exact matches first
  if (BRANDING_CONFIG[hostname]) {
    return hostname;
  }

  // Check for subdomain matches (e.g., www.isogyaan.com -> isogyaan.com)
  const domain = hostname.replace(/^www\./, "");
  if (BRANDING_CONFIG[domain]) {
    return domain;
  }

  // Check for partial matches in hostname (useful for staging subdomains)
  if (hostname.includes("procertcompliance")) return "procertcompliance.com";
  if (hostname.includes("skillcompliance.ca")) return "skillcompliance.ca";
  if (hostname.includes("skillcompliance")) return "skillcompliance.com";
  if (hostname.includes("isogyaan")) return "isogyaan.com";

  // Partner custom domains (e.g. onlineisotraining.isocertification.ca) run on
  // the ProCert platform. The edge function signals this via meta tags.
  if (getPartnerContextFromDOM()) return "procertcompliance.com";

  // Default fallback
  return "isogyaan.com";
};

// Get current branding
export const getCurrentBranding = () => {
  const domain = getCurrentDomain();
  const base = BRANDING_CONFIG[domain] || BRANDING_CONFIG["isogyaan.com"];

  const partner = getPartnerContextFromDOM();
  let edge;
  try { edge = JSON.parse(document.getElementById('site-branding')?.textContent || 'null'); } catch { /* Local development has no edge payload. */ }
  if (edge) return {
    ...base, partnerSlug:edge.partnerSlug, name:edge.appName, fullName:edge.appName, siteUrl:edge.siteUrl,
    description:edge.description, ogImage:edge.ogImage,
    logo:edge.favicon, logoFull:edge.partnerSlug || edge.unresolvedPartner ? edge.favicon : base.logoFull,
    meta:{title:edge.title, description:edge.description, keywords:edge.partnerSlug ? '' : base.meta.keywords},
    ...(edge.partnerSlug || edge.unresolvedPartner ? {isPartner:true,social:{},address:{},geo:{},email:edge.email || '',phone:edge.phone || ''} : {}),
  };
  if (partner?.name) return {
    ...base, isPartner:true, partnerSlug:partner.slug, name:partner.name, fullName:partner.name,
    logo:"/favicon.svg",logoFull:"/favicon.svg",ogImage:"/favicon.svg",
    siteUrl:window.location.origin, social:{},address:{},geo:{},
    meta:{title:partner.name,description:`Professional training by ${partner.name}.`,keywords:''},
  };
  if (typeof window !== 'undefined') {
    const host = window.location.hostname.replace(/^www\./, '');
    if (!BRANDING_CONFIG[host] && host !== 'localhost' && host !== '127.0.0.1' && !host.endsWith('.netlify.app')) return {
      ...base,isPartner:true,name:'Training',fullName:'Training',siteUrl:window.location.origin,
      description:'Professional training courses.',logo:'/favicon.svg',logoFull:'/favicon.svg',ogImage:'/favicon.svg',
      social:{},address:{},geo:{},email:'',phone:'',meta:{title:'Training',description:'Professional training courses.',keywords:''},
    };
  }

  return base;
};

// Export individual branding properties for convenience
export const BRANDING = getCurrentBranding();

// Re-export for backward compatibility with existing env vars
export const SITE_NAME = BRANDING.fullName;
export const SITE_URL = BRANDING.siteUrl;
export const BUSINESS_EMAIL = BRANDING.email;
export const BUSINESS_PHONE = BRANDING.phone;

export default BRANDING;
